query PlatformMenuItem($id: ID!) {
  platformMenuItem(id: $id) {
    id
    index
    label
    publishAt
    linkType
    href
    targetType
    targetId
    targetTitle
    targetUrl
    visibilityConditions {
      userType
      countries {
        type
        countryCodes
      }
      applicationPlatforms {
        type
        platforms
      }
    }
  }
}
